export const PREFERENCES = Object.freeze({
  GENERAL: 'General',
  FOOTER: 'Footer',
  TEXT_CONTENT: 'TextContent',
  VIRTUAL_BRANDS: 'VirtualBrands',
  NAVIGATION_RESOLVER: 'NavigationResolver',
})
